import React, { useCallback, useState } from 'react';

function parseCSV(text) {
  const raw = text.replace(/^\uFEFF/, '').trim();
  if (!raw) return null;
  const lines = [];
  let i = 0;
  while (i < raw.length) {
    const row = [];
    while (i < raw.length && raw[i] !== '\n' && raw[i] !== '\r') {
      if (raw[i] === '"') {
        i++;
        let cell = '';
        while (i < raw.length) {
          if (raw[i] === '"') {
            i++;
            if (raw[i] === '"') {
              cell += '"';
              i++;
            } else break;
          } else {
            cell += raw[i++];
          }
        }
        row.push(cell);
        if (raw[i] === ',') i++;
      } else {
        let cell = '';
        while (i < raw.length && raw[i] !== ',' && raw[i] !== '\n' && raw[i] !== '\r') {
          cell += raw[i++];
        }
        row.push(cell.replace(/^"|"$/g, '').replace(/""/g, '"'));
        if (raw[i] === ',') i++;
      }
    }
    if (row.some((c) => c.trim() !== '')) lines.push(row);
    if (raw[i] === '\r') i++;
    if (raw[i] === '\n') i++;
  }
  if (lines.length < 2) return null;
  const headers = lines[0].map((h) => h.trim().toLowerCase().replace(/\s+/g, '_'));
  const headerMap = {};
  headers.forEach((h, idx) => {
    headerMap[h] = idx;
    const alt = h.replace(/_/g, '');
    if (!headerMap[alt]) headerMap[alt] = idx;
  });
  const getCol = (row, ...names) => {
    for (const n of names) {
      const idx = headerMap[n?.toLowerCase?.() || n];
      if (idx != null && row[idx] !== undefined && row[idx] !== null) {
        const v = String(row[idx]).trim();
        return v || '';
      }
    }
    return '';
  };
  const doctors = [];
  for (let r = 1; r < lines.length; r++) {
    const row = lines[r];
    const primary_name = getCol(row, 'primary_name', 'name', 'primaryname');
    const speciality = getCol(row, 'speciality', 'specialty');
    const service_provided = getCol(row, 'service_provided', 'serviceprovided') || '';
    const gender = getCol(row, 'gender') || null;
    const type = getCol(row, 'type') || 'doctor';
    let meta_data = getCol(row, 'meta_data', 'metadata');
    if (meta_data) {
      try {
        meta_data = JSON.parse(meta_data);
      } catch {
        meta_data = null;
      }
    } else meta_data = null;
    const external_doctor_code = getCol(row, 'external_doctor_code', 'externaldoctorcode') || null;
    doctors.push({
      primary_name,
      speciality,
      service_provided,
      gender: gender || null,
      type: type || 'doctor',
      meta_data,
      external_doctor_code,
    });
  }
  return doctors;
}

function parseFlexibleExtractRow(row) {
  const serviceProvided = Array.isArray(row.service_provided)
    ? row.service_provided.join('; ')
    : (row.service_provided || '');
  let metaData = row.meta_data;
  if (typeof metaData === 'string' && metaData.trim()) {
    try {
      metaData = JSON.parse(metaData);
    } catch {
      metaData = null;
    }
  }
  return {
    primary_name: row.primary_name || '',
    speciality: row.specialty || row.speciality || '',
    service_provided: serviceProvided,
    gender: row.gender || null,
    type: row.type || 'doctor',
    meta_data: metaData || null,
    external_doctor_code: row.external_doctor_code || null,
  };
}

function parseInput(json) {
  if (Array.isArray(json)) {
    return json.map(parseFlexibleExtractRow);
  }
  if (json?.clinic_doctors && Array.isArray(json.clinic_doctors)) {
    return json.clinic_doctors.map((d) => ({
      primary_name: d.primary_name || '',
      speciality: d.speciality || '',
      service_provided: typeof d.service_provided === 'string'
        ? d.service_provided
        : (Array.isArray(d.service_provided) ? d.service_provided.join('; ') : ''),
      gender: d.gender || null,
      type: d.type || 'doctor',
      meta_data: d.meta_data || null,
      external_doctor_code: d.external_doctor_code || null,
    }));
  }
  return null;
}

const CLID7715_JSON = [
  { primary_name: 'Dr. Sandeep Jain 牙醫', speciality: '全科牙醫', service_provided: '種植牙; 骨移植; All on 4 全口種牙; 美容牙科; 牙齒貼片; 剝牙; 假牙; 牙周病治療; 牙齒美白; 睡眠窒息症', gender: null, type: 'doctor', meta_data: { i18n: { name: { en_US: 'Dr. Sandeep Jain', zh_HK: 'Dr. Sandeep Jain 牙醫', zh_CN: '' } } } },
  { primary_name: '臧薇敏牙醫', speciality: '口腔頜面外科專科醫生', service_provided: '種植牙; 骨移植; All on 4 全口種牙; 上顎竇提升術', gender: null, type: 'doctor', meta_data: { i18n: { name: { en_US: 'Dr. Chong Mei Man', zh_HK: '臧薇敏牙醫', zh_CN: '' } } } },
  { primary_name: '李廸信牙醫', speciality: '口腔頜面外科專科醫生', service_provided: '種植牙; 骨移植; All on 4 全口種牙; 上顎竇提升術; 顳顎關節(TMJ); 下顎疼痛', gender: null, type: 'doctor', meta_data: { i18n: { name: { en_US: 'Dr. Li Tik Shun, Dion', zh_HK: '李廸信牙醫', zh_CN: '' } } } },
  { primary_name: 'Dr. Duncan Scorgie 牙醫', speciality: '全科牙醫', service_provided: '美容牙科; 重建笑容; 牙齒貼片; 全口種牙', gender: null, type: 'doctor', meta_data: { i18n: { name: { en_US: 'Dr. Duncan Mckay Scorgie', zh_HK: 'Dr. Duncan Scorgie 牙醫', zh_CN: '' } } } },
  { primary_name: '麥穎恒牙醫', speciality: '全科牙醫', service_provided: '家庭牙醫; 隱適美 隱形牙套; 牙冠; 牙齒貼片; 美白牙齒', gender: null, type: 'doctor', meta_data: { i18n: { name: { en_US: 'Dr. Mak Wing Hang, Bella', zh_HK: '麥穎恒牙醫', zh_CN: '' } } } },
  { primary_name: '劉嘉儀牙醫', speciality: '全科牙醫', service_provided: 'Dental Implants; Crowns; Veneers; Dentures; Invisalign; Kids Dentist; Teeth Whitening; 種植牙; 牙冠; 牙齒貼片; 假牙; 隱適美箍牙; 兒童牙醫; 美白牙齒', gender: null, type: 'doctor', meta_data: { i18n: { name: { en_US: 'Dr. Lau Ka Yee, Iris', zh_HK: '劉嘉儀牙醫', zh_CN: '' } } } },
  { primary_name: 'Dr. Chamila Panduwawala', speciality: '全科牙醫', service_provided: '牙冠; 美白牙齒; 牙齒貼片; 隱適美; Dental Crowns; Teeth Whitening; Dental Veneers; Invisalign', gender: null, type: 'doctor', meta_data: { i18n: { name: { en_US: 'Dr. Chamila Panduwawala', zh_HK: 'Dr. Chamila Panduwawala', zh_CN: '' } } } },
  { primary_name: 'Blanche Ma 牙齒衛生員', speciality: '牙齒衛生員', service_provided: '牙齒衛生; Dental Hygiene', gender: null, type: 'doctor', meta_data: { i18n: { name: { en_US: 'Blanche Ma', zh_HK: 'Blanche Ma 牙齒衛生員', zh_CN: 'Blanche Ma 牙齿卫生员' } } } },
  { primary_name: 'Kate Lam 牙齒衛生員', speciality: '牙齒衛生員', service_provided: '牙齒衛生; Dental Hygiene', gender: null, type: 'doctor', meta_data: { i18n: { name: { en_US: 'Kate Lam', zh_HK: 'Kate Lam 牙齒衛生員', zh_CN: 'Kate Lam 牙齿卫生员' } } } },
  { primary_name: 'Leagh Oppers 牙齒衛生員', speciality: '牙齒衛生員', service_provided: '牙齒衛生; Dental Hygiene', gender: null, type: 'doctor', meta_data: { i18n: { name: { en_US: 'Leagh Oppers', zh_HK: 'Leagh Oppers 牙齒衛生員', zh_CN: '' } } } },
  { primary_name: 'Monika Jain 牙齒衛生員', speciality: '牙齒衛生員', service_provided: '牙齒衛生; Dental Hygiene', gender: null, type: 'doctor', meta_data: { i18n: { name: { en_US: 'Monika Jain', zh_HK: 'Monika Jain 牙齒衛生員', zh_CN: '' } } } },
  { primary_name: '張文偉牙醫', speciality: '牙髓病學', service_provided: '杜牙根治療; Root Canal Treatment', gender: null, type: 'doctor', meta_data: { i18n: { name: { en_US: 'Dr. Chang Wen Wei, Jeffrey', zh_HK: '張文偉牙醫', zh_CN: '' } } } },
  { primary_name: 'Dr. Selina Chhabra Rampal 牙醫', speciality: '兒童牙醫', service_provided: '兒童牙醫 鎮靜牙科; Paediatric (Kids) Dentist Under Sedation Dentistry', gender: null, type: 'doctor', meta_data: { i18n: { name: { en_US: 'Dr. Selina Chhabra Rampal', zh_HK: 'Dr. Selina Chhabra Rampal 牙醫', zh_CN: '' } } } },
  { primary_name: '袁潔臻牙醫', speciality: '牙齒矯正專科牙醫', service_provided: '箍牙; 隱適美 隱形牙套', gender: null, type: 'doctor', meta_data: { i18n: { name: { en_US: 'Dr. Yuen Kit Zin, Michelle', zh_HK: '袁潔臻牙醫', zh_CN: '' } } } },
  { primary_name: 'Dr. Constanza María Araya 牙醫', speciality: '全科牙醫', service_provided: '牙冠; 杜牙根治療; Dental Crowns; Root Canal Treatment', gender: null, type: 'doctor', meta_data: { i18n: { name: { en_US: 'Dr. Constanza María Araya', zh_HK: 'Dr. Constanza María Araya 牙醫', zh_CN: '' } } } },
  { primary_name: '周惠惠牙醫', speciality: '牙周病學專家', service_provided: '牙周病治療; Gum Disease Treatment', gender: null, type: 'doctor', meta_data: { i18n: { name: { en_US: 'Dr. Chiu Joy Ngo, Joanna', zh_HK: '周惠惠牙醫', zh_CN: '' } } } },
];

const PRESETS = [
  {
    id: 'clear',
    name: 'Clear',
    description: 'Reset input to empty',
    text: '',
  },
  {
    id: 'clid7715-json-example',
    name: 'CLID7715 JSON Example',
    description: 'Doctor list JSON from Flexible Extract (16 doctors)',
    text: JSON.stringify(CLID7715_JSON, null, 2),
  },
];

const Step1_Input = ({ onNext, loading, error, setError }) => {
  const [pasteText, setPasteText] = useState('');
  const [fileContent, setFileContent] = useState(null);
  const [parseError, setParseError] = useState('');

  const processText = useCallback((text) => {
    const trimmed = text.trim();
    if (!trimmed) return null;
    try {
      const json = JSON.parse(trimmed);
      return parseInput(json);
    } catch {
      const csvDoctors = parseCSV(trimmed);
      return csvDoctors;
    }
  }, []);

  const handleFileChange = useCallback((e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const isJson = file.name.endsWith('.json') || file.type === 'application/json';
    const isCsv = file.name.endsWith('.csv') || file.type === 'text/csv';
    if (!isJson && !isCsv) {
      setError('Please upload a JSON or CSV file');
      return;
    }
    setError('');
    setParseError('');
    const reader = new FileReader();
    reader.onload = (ev) => {
      const doctors = processText(ev.target.result);
      if (!doctors || doctors.length === 0) {
        setParseError(
          isJson
            ? 'No doctors found. Expected array of doctor objects or { clinic_doctors: [...] }'
            : 'No doctors found. CSV needs header row with primary_name, speciality (or specialty), etc.'
        );
        setFileContent(null);
      } else {
        setFileContent(doctors);
        setPasteText('');
      }
    };
    reader.readAsText(file, 'UTF-8');
  }, [setError, processText]);

  const handlePasteChange = useCallback((e) => {
    const text = e.target.value;
    setPasteText(text);
    setParseError('');
    setFileContent(null);
    if (!text.trim()) return;
    const doctors = processText(text);
    if (!doctors || doctors.length === 0) {
      setParseError('No doctors found. Paste JSON or CSV with primary_name, speciality columns.');
    } else {
      setFileContent(doctors);
    }
  }, [processText]);

  const handleRemoveFile = useCallback(() => {
    setFileContent(null);
    setPasteText('');
    setParseError('');
    setError('');
  }, [setError]);

  const handleNext = useCallback(() => {
    if (!fileContent || fileContent.length === 0) {
      setError('Please paste or upload valid JSON or CSV with doctors');
      return;
    }
    const invalid = fileContent.filter((d) => !d.primary_name || !d.speciality);
    if (invalid.length > 0) {
      setError(`${invalid.length} doctor(s) missing primary_name or speciality`);
      return;
    }
    setError('');
    onNext(fileContent);
  }, [fileContent, onNext, setError]);

  const doctorsCount = fileContent?.length || 0;

  return (
    <div className="space-y-6">
      <div className="text-center">
        <h2 className="text-2xl font-bold text-gray-900 mb-2">Step 1: Input JSON or CSV</h2>
        <p className="text-gray-600">
          Paste or upload JSON/CSV from Flexible Extract (Doctor Page to Doctor List) or clinic_doctors format. Schedules are ignored; only doctors will be imported.
        </p>
      </div>

      <div className="bg-gray-50 p-6 rounded-lg space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Paste JSON or CSV</label>
          <textarea
            value={pasteText}
            onChange={handlePasteChange}
            placeholder='JSON: [{"primary_name":"...","specialty":"..."}] or CSV: primary_name,speciality,service_provided,...'
            className="w-full px-4 py-2 border border-gray-300 rounded-md font-mono text-sm h-32"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Or upload file</label>
          <input
            type="file"
            accept=".json,application/json,.csv,text/csv"
            onChange={handleFileChange}
            className="block w-full text-sm text-gray-600"
          />
        </div>
        {parseError && <p className="text-sm text-red-600">{parseError}</p>}
      </div>

      {fileContent && (
        <div className="flex items-center justify-between p-4 bg-white border border-green-200 rounded-lg">
          <span className="text-sm font-medium text-green-800">
            {doctorsCount} doctor{doctorsCount !== 1 ? 's' : ''} parsed
          </span>
          <button
            type="button"
            onClick={handleRemoveFile}
            className="text-red-600 hover:text-red-700 text-sm"
          >
            Clear
          </button>
        </div>
      )}

      <div className="bg-gray-50 p-6 rounded-lg">
        <label className="block text-sm font-medium text-gray-700 mb-3">Example templates</label>
        <p className="text-xs text-gray-500 mb-3">Click a block to paste into input.</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {PRESETS.map((preset) => (
            <button
              key={preset.id}
              type="button"
              onClick={() => {
                setPasteText(preset.text);
                const doctors = preset.text ? processText(preset.text) : null;
                setFileContent(doctors);
                setParseError('');
              }}
              className="text-left p-4 bg-white border border-gray-200 rounded-lg hover:border-blue-400 hover:bg-blue-50/50 transition-colors"
            >
              <div className="font-medium text-gray-900">{preset.name}</div>
              <div className="text-xs text-gray-600 mt-1">{preset.description}</div>
            </button>
          ))}
        </div>
      </div>

      {error && (
        <div className="bg-red-50 border border-red-200 rounded-lg p-4 text-red-800">{error}</div>
      )}

      <div className="flex justify-end">
        <button
          onClick={handleNext}
          disabled={!fileContent || fileContent.length === 0 || loading}
          className="px-8 py-3 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed font-medium"
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Step1_Input;
